/* Collection page — client-side sorting of product cards */
(function () {
  'use strict';

  function init() {
    var grid = document.getElementById('collection-grid');
    var select = document.getElementById('collection-sort');
    if (!grid || !select) return;

    function sortCards(mode) {
      var cards = Array.prototype.slice.call(grid.querySelectorAll('.clx-card'));
      cards.sort(function (a, b) {
        var pa = parseFloat(a.dataset.price) || 0;
        var pb = parseFloat(b.dataset.price) || 0;
        var ta = (a.dataset.title || '').toLowerCase();
        var tb = (b.dataset.title || '').toLowerCase();
        var ia = parseInt(a.dataset.index, 10) || 0;
        var ib = parseInt(b.dataset.index, 10) || 0;
        switch (mode) {
          case 'price-asc': return pa - pb || ia - ib;
          case 'price-desc': return pb - pa || ia - ib;
          case 'alpha-asc': return ta < tb ? -1 : ta > tb ? 1 : 0;
          case 'alpha-desc': return ta > tb ? -1 : ta < tb ? 1 : 0;
          case 'date-desc': return ib - ia;
          case 'date-asc': return ia - ib;
          default: return ia - ib; // best selling = original order
        }
      });
      cards.forEach(function (c) { grid.appendChild(c); });
    }

    select.addEventListener('change', function () {
      sortCards(select.value);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
